// Cookie consent state for bibaelectronics.com.
//
// The choice lives in localStorage ("biba_cookie_consent") and is pushed to
// Google as Consent Mode v2 signals. public/index.html sets every
// non-essential signal to "denied" before any Google tag loads and replays a
// stored choice, so a first-time visitor gets no analytics or advertising
// cookies until they opt in here.
const KEY = "biba_cookie_consent";
const VERSION = 1; // bump to ask everyone again after a material change
const MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000;
export const OPEN_EVENT = "biba:open-cookie-settings";

export function readConsent() {
  try {
    const c = JSON.parse(window.localStorage.getItem(KEY) || "null");
    if (c && c.v === VERSION && Date.now() - c.ts < MAX_AGE_MS) return c;
  } catch (e) {
    /* storage blocked or corrupt: treat as "no choice yet" */
  }
  return null;
}

function gtagUpdate(analytics, marketing) {
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
}

// Google's cookies stay in the browser after consent is withdrawn, so remove
// them on the page's domain and its parent domain.
function clearGoogleCookies(analytics, marketing) {
  const doomed = (name) =>
    (!analytics && /^(_ga|_gid|_gat)/.test(name)) || (!marketing && /^(_gcl_|IDE$|test_cookie$)/.test(name));
  const host = window.location.hostname;
  const domains = ["", host, "." + host, "." + host.replace(/^www\./, "")];
  document.cookie.split(";").forEach((pair) => {
    const name = pair.split("=")[0].trim();
    if (!doomed(name)) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`;
    });
  });
}

export function saveConsent(analytics, marketing) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ v: VERSION, analytics, marketing, ts: Date.now() }));
  } catch (e) {
    /* still apply it for this page view */
  }
  gtagUpdate(analytics, marketing);
  clearGoogleCookies(analytics, marketing);
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}
